import { Component, Injector, Input } from '@angular/core';

import { ApAlertService } from '../ap-alert/index';
import { ApComplexModal } from '../modals/index';

@Component({
  selector: 'ap-file-upload-import-modal',
  templateUrl: './ap-file-upload-modal.component.html',
  providers: [
    ApAlertService,
  ],
})
export class ApFileUploadModalComponent extends ApComplexModal<File> {
  @Input() allowedExtensions?: string;
  @Input() message?: string;
  @Input() title?: string;

  selectedFile?: File;

  constructor(
    elementInjector: Injector,
    private readonly apAlertService: ApAlertService,
  ) {
    super(elementInjector);
  }

  displayError(event: string) {
    this.apAlertService.clearAllErrorAlerts();

    if (event) {
      this.apAlertService.error(event);
    }
  }

  filesChanged(files: File[]) {
    this.selectedFile = files[0];
  }

  cancel() {
    this.apUserCancel();
  }

  close() {
    if (this.selectedFile) {
      this.apClose(this.selectedFile);
    }
  }
}
